<template>
    <div class="page">
        <div class="header">
            <Header :current="['zt']"></Header>
            <div class="zt-title">商河县主体名录库</div>
            <div class="header-search">
<!--                <a-input-search-->
<!--                    placeholder="输入搜索内容"-->
<!--                />-->
            </div>
        </div>
        <div class="content">
            <div class="zt-btn">
                <a-space direction="vertical">
                    <a-button type="primary" @click="handleAdd"><template #icon><DiffOutlined /></template>主体申报</a-button>
                    <a-button type="primary" @click="farmerRegister"><template #icon><DiffOutlined /></template>小农户注册</a-button>
                </a-space>
            </div>
            <div class="zt-area">
                <div class="zt-area-b" v-for="(item, i) in areaList" :key="i" @click="handleClick(item.townId)">
                    <div class="zt-area-b-circle">
                        <img :src="item.icon">
                    </div>
                    <p>{{ item.name }}</p>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import { DiffOutlined } from '@ant-design/icons-vue'
import router from "@/router"
const shx = require('@/assets/img/shanghe.png')
const bq = require('@/assets/img/baiqiao.png')
const hm = require('@/assets/img/hanmiao.png')
const hr = require('@/assets/img/huairen.png')
const jz = require('@/assets/img/jiazhuang.png')
const lss = require('@/assets/img/longsangsi.png')
const shz = require('@/assets/img/shahe.png')
const sj = require('@/assets/img/sunji.png')
const xs = require('@/assets/img/xushang.png')
const yhm = require('@/assets/img/yuhuangmiao.png')
const yx = require('@/assets/img/yinxiang.png')
const zf = require('@/assets/img/zhangfang.png')
const zl = require('@/assets/img/zhenglu.png')
const jjkfq = require('@/assets/img/kaifaqu.png')
export default {
    name: "MingLu",
    setup() {
        const areaList = [
            {name: '商河县', icon: shx, townId: null},
            {name: '经济开发区', icon: jjkfq, townId: '6148'},
            {name: '殷巷镇', icon: yx, townId: '5162'},
            {name: '怀仁镇', icon: hr, townId: '5163'},
            {name: '龙桑寺镇', icon: lss, townId: '5164'},
            {name: '郑路镇', icon: zl, townId: '5165'},
            {name: '贾庄镇', icon: jz, townId: '5166'},
            {name: '玉皇庙镇', icon: yhm, townId: '5167'},
            {name: '白桥镇', icon: bq, townId: '5168'},
            {name: '孙集镇', icon: sj, townId: '5169'},
            {name: '韩庙镇', icon: hm, townId: '5170'},
            {name: '沙河镇', icon: shz, townId: '5171'},
            {name: '张坊镇', icon: zf, townId: '5172'},
            {name: '许商街道', icon: xs, townId: '6048'},

        ]
        return {
            areaList
        }
    },
    methods: {
        handleClick(townId) {
            router.push({
                path: 'MingLuTable',
                query: {townId: townId}
            })
        },
        handleAdd() {
            router.push({
                path: 'MingLuAdd'
            })
        },
        farmerRegister() {
            router.push({
                path: 'farmerRegister'
            })
        }
    },
    components: {
        Header,
        Footer,
        DiffOutlined
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        position relative
        font-size 16px
        background-color #FFF
        .header {
            width 100%
            height 730px
            padding-top 130px
            box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
            border-bottom-left-radius 315px
            border-bottom-right-radius 315px
            background-image url("../../assets/img/portal_service_bg.png")
            background-size 100% 100%
            background-repeat no-repeat
            .zt-title {
                margin-top 200px
                width 100%
                font-size 48px
                color #FFF
                font-weight bold
                text-align center
            }
            .header-search {
                width 600px
                height 70px
                margin 60px auto 200px auto
            }
            .header-search >>> .ant-input-affix-wrapper {
                height 70px
                font-size 22px
            }
            .header-search >>> .ant-input-affix-wrapper > input.ant-input {
                border-radius 5.333vw
                font-size 18px
                padding 4px 20px
            }
            .header-search >>> .ant-input-affix-wrapper .ant-input-suffix {
                margin-right 10px
            }
        }
        .content {
            width 100%
            min-height 200px
            margin-top 30px
            .zt-btn {
                width 100%
                padding 0 110px
                text-align right
            }
            .zt-btn >>> .ant-btn {
                width 140px
                height 45px
                line-height 45px
                border-radius 8px
                font-size 18px
            }
            .zt-area {
                width 100%
                display flex
                flex-wrap wrap
                justify-content space-evenly
                padding-bottom 80px
                padding-left 400px
                padding-right 400px
                .zt-area-b {
                    text-align center
                    font-size 24px
                    font-weight bold
                    color #167ADA
                    cursor pointer
                    margin 25px
                    transition .2s
                    .zt-area-b-circle {
                        width 100px
                        height 100px
                        line-height 100px
                        text-align center
                        border-radius 50%
                        //border 1px solid #167ADA
                        margin-bottom 17px
                        overflow hidden
                        background #FFF
                    }
                    .zt-area-b-circle img {
                        width 100%
                    }
                }
                .zt-area-b:hover {
                    transform scale(1.3)
                }
            }
        }
    }
</style>